import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
// -- components --
import { CompCardsComponent } from '../comp-cards/comp-cards.component';
import { CardType4Component } from '../../../components/card-type-4/card-type-4.component';

interface CapacityCard {
    formid: number;
    imagemobile: string;
    imagedesktop: string;
    imagetablet: string;
    switchergroup: string;
    institution: string;
    cta: string;
    id: number;
    description: string;
    title: string;
    publishdate: string;
    url: string;
    formalias: string;
    category?: string;
}

@Component({
    selector: 'app-step-2',
    standalone: true,
    imports: [CommonModule, CompCardsComponent, CardType4Component],
    templateUrl: './step-2.component.html',
    styleUrl: './step-2.component.scss',
})
export class Step2Component implements OnInit, OnChanges {
    @Input() toolsCards: CapacityCard[] = [];
    visibleCount: number = 6; // default for desktop
    increment: number = 6; // how many to add on "Show More"
    isMobile: boolean = false;
    gaPrefix = 'tools_&_resources_learn_more_';

    ngOnInit(): void {
        this.setVisibleCount();
        // Optional: Update on window resize
        window.addEventListener('resize', () => this.setVisibleCount());
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['toolsCards'] && this.toolsCards) {
            this.setVisibleCount();
        }
    }

    setVisibleCount() {
        const width = window.innerWidth;
        if (this.visibleCount <= 7) {
            if (width < 1028) {
                // iPad Mini / iPad Air / Mobile
                this.visibleCount = 4;
                this.increment = 4;
            } else {
                // Desktop & iPad Pro
                this.visibleCount = 6;
                this.increment = 6;
            }
        }
    }

    showMore(): void {
        this.visibleCount += this.increment;
    }

    openLink(url: string): void {
        if (url && url.trim()) {
            let finalUrl = url.trim();
            if (
                !finalUrl.startsWith('http://') &&
                !finalUrl.startsWith('https://')
            ) {
                finalUrl = 'https://' + finalUrl;
            }
            window.open(finalUrl, '_blank', 'noopener,noreferrer');
        }
    }
}
